<template>
<ITMPage>
    <h2>Notifications</h2>
    <DataTableAsync class="mt-3" :data="tableData" v-model="tableState" :length="(data || []).length" ref="dataTable" noSearch>   
    <template #head>
      <th></th>
  </template>
      <template #body="{ item }">
        <tr :class="{isNotRead:!item.isRead}">
          <td>Document <b>{{ item.document.fileName }}</b> attached to customer <b>{{ item.customerFacility }}</b> and order <b>#{{ item.orderId }}</b> is about to expire on <b>{{dateFormat(item.document.expirationDate)||'-'}}</b></td>
          
          <td class="text-center">
        <v-menu
        :close-on-content-click="false"
        :nudge-width="100"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
           <v-btn
          color="primary" 
          v-bind="attrs" v-on="on" @click.stop.prevent="selectedItem=null;menu=true"
        >
          <v-icon>mdi-clock-outline</v-icon>
          Snooze
        </v-btn>
        </template>
  
        <v-card v-if="menu">
          <v-list>
            <v-list-tile :value="selectedItem" @click="selectedItem=i;"
          v-for="(i, index) in numOfDays"
          :key="index"
          :class="{'selected': selectedItem === i}"
        >
          <v-list-tile-title>{{ i }} days</v-list-tile-title>
        </v-list-tile>
          </v-list>
  
          <v-divider></v-divider>

          <v-card-actions>
             <v-spacer></v-spacer>
        <v-btn text @click="menu = false">Cancel</v-btn>
        <v-btn color="primary" text :disabled="selectedItem===null" @click="menu = false; snoozeNotification(item.id,selectedItem)">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
          </td>
          <td>
    <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn 
        @click="toggleReadStatus(item.id)" 
        :disabled="item.isRead"
        v-bind="attrs"
        v-on="on">
        <v-icon>{{ item.isRead ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon>
      </v-btn>
    </template>
    <span>{{ item.isRead ? 'Mark as unread' : 'Mark as read' }}</span>
  </v-tooltip>
          </td>
        </tr>
      </template>
    </DataTableAsync>
    <Loader v-if="isLoading" />
    </ITMPage>
</template>

<script>
import ITMPage from '../../components/itm/ITMPage.vue';
import DataTableAsync from '../../components/common/dataTable/DataTableAsync.vue';
import Th from '../../components/common/dataTable/Th.vue';
import axios from '../../axios';
import { errorDebug, } from '../../libraries/common';
export default {
  components: { ITMPage, DataTableAsync, Th},
  data() {
    return {
      data: null,
      tableState: { page: 1, perPage: 25},
      isLoading: false,
      numOfDays: [
        '0', '25', '50','100'
      ],
    menu: false,
    selectedItem:null
    };
  },
  mounted() {
    this.fetchNotifications();
  },
  computed: {
    daySelected(){
      return this.numOfDays[this.selectedItem];
    },
    sortedData() {
      var response = (this.data || []);

      if (this.tableState.sortByProp) {
        response = response.sortBy(this.tableState.sortByProp);
        if (this.tableState.sortDirection === 'desc')
          response = response.reverse();
      }
      return response;
    },
    tableData() {
      return this.sortedData
        .skip(this.tableState.perPage * (this.tableState.page - 1))
        .take(this.tableState.perPage);
    },
    isAdmin() {
      return this.$store.state.user.isMainAdmin || this.$store.state.user.isAdmin;
    }
  },
  methods: {
    getUnReadNotificationsCount(){
      axios.get(`/ITM/Notification/GetUnReadNotificationsCount`).then(({data} ) =>{
        this.$store.state.itm.notificationCount=data;
      })
        .catch(errorDebug)
    },
     fetchNotifications() {
        this.isLoading = true;
        axios.get(`/ITM/Notification/GetNotifications`).then(({ data }) => this.data = data)
        .catch(errorDebug)
        .then(() => this.isLoading = false);
        },
        
    snoozeNotification(notificationId,item) {
      const days=item;
      if (days) {
        this.isLoading = true;
        axios.post(`/ITM/Notification/${notificationId}/snooze`,JSON.stringify(Number(days))) 
            .then(({data})=>{
              if(!data) this.$notify(`Unable to snooze for ${item} days!`)
              else{
            this.fetchNotifications();
            }
          this.menu=false;
            }).catch(errorDebug)
        .then(() => this.isLoading = false);  
      }
    },
    
    toggleReadStatus(notificationId) {
      this.isLoading = true;
      axios.post(`/ITM/Notification/${notificationId}/read-status`)
      .then(()=>{
        this.getUnReadNotificationsCount();
        this.fetchNotifications();
        })
      .catch (errorDebug)
      .then(() => this.isLoading = false)
    }
  }
};
</script>

<style scoped>
.selected {
  background-color: rgba(0, 0, 0, 0.1); 
}
.isNotRead{
 background-color: #c7dde7;
}
.isNotRead:hover {
    background-color: #c7dde7 !important;
}
</style>
